import Link from "next/link";
import React from "react";

export default function CategoryTitle({ titleName, titleSlug }) {
  return (
    <h1 className="">
      <Link
        className="inline-block py-1 text-5xl font-light text-black"
        href={`/${titleSlug}`}
      >
        {titleName}
      </Link>
    </h1>
  );
}
